<template>
  <div class="container-12 body">
    <template v-if="errorMessage != ''">
      <div class="alert alert-danger" role="alert">
        {{ errorMessage }}
      </div>
    </template>
    <div class="row justify-content-center">
      <div class="col-11 col-sm-8">
        <div class="py-3 text-center">
          <h3 class="title">ご予約内容</h3>
            <div class= "border bg-light p-3">
              <div class="row border-bottom">
                <div class="col">ご予約日</div>
                <div class="col">{{ reserveDate }}</div>
              </div>
              <div class="row border-bottom">
                <div class="col">ご予約時間</div>
                <div class="col">
                  {{ reserveFromTime.label }} ～ {{ reserveToTime.label }}
                </div>
              </div>
              <div class="row border-bottom">
                <div class="col">ご予約人数</div>
                <div class="col">{{ personNum }}人</div>
              </div>
              <div class="row border-bottom">
                <div class="col" v-if="isFree()">訪問者</div>
                <div class="col" v-else>代表訪問者</div>
                <div class="col">
                  <template v-for="(num, index) in personNum" :key="index" >
                    <div v-if="visiters[index] ">{{ visiters[index] }}<br></div>
                  </template>
                </div>
              </div>
              <div class="row">
                <div class="col" v-if="isHall()">利用目的</div>
                <div class="col" v-else>ご利用メモ</div>
                <div class="col">{{ memo }}</div>
              </div>
              <div class="row mt-2">
                <div class="col">
                  <button type="button" class="btn btn-secondary w-75"
                    @click="cancelClick()" :disabled="isButtonDisabled">キャンセル</button>
                </div>
                <div class="col">
                  <button type="button" class="btn btn-primary w-75"
                    @click="reserveConfirmClick()" :disabled="isButtonDisabled">予約確定</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import reserveMixin from '@/mixins/reserveMixin.js'
import authMixins from '@/mixins/authMixin.js'
import Const from '../const'
import axios from 'axios'

export default {
  name: 'ReserveConfirm',

  data: () => ({
    errorMessage: '',
    isButtonDisabled: false,
  }),
  created() {
    // ストアに予約情報が存在しない場合、予約一覧画面へ遷移
    this.transitionRoomList();
  },
  methods: {
    cancelClick: function() {
      // 予約画面へ遷移
      this.$router.push({ name: 'reserveRoom' });
    },
    reserveConfirmClick: function() {
      this.isButtonDisabled = true;
      var visiters = [];
      this.visiters.forEach((ele) => visiters.push({ "name": !ele ? "" : ele, "status": "" }));
      var params = {
        "plan_id": this.plan,
        "reservation_date": this.reserveDate.replaceAll("-", ""),
        "start_time": this.reserveFromTime.label.replaceAll(":", ""),
        "end_time": this.reserveToTime.label.replaceAll(":", ""),
        "people_num": this.personNum,
        "visiters": visiters,
        "system_name": "web",
        "regist_name": "",
        "free_reseve": this.freeReseve,
        "memo": this.memo,
      };
      // console.log(params);
      axios.post(Const.BASE_URL + "/reservation",
      params, {
        headers: {
          "Authorization": this.token,
          "Content-Type": "application/json"
        }
      }).then(() => {
        // console.log(response)
        // 予約完了画面へ遷移
        this.$router.push({ name: 'reserveComplete' });
      }).catch(function(error) {
        // console.log(error);
        if ("409" == error.response.status) {
          // 排他エラー
          this.errorMessage = '既に予約されているため日時を変更して予約し直してください。';
        } else {
          // その他エラー
          this.errorMessage = 'エラーが発生しました。';
        }
        this.isButtonDisabled = false;
      }.bind(this));
    },
  },
  mixins: [reserveMixin, authMixins],
}
</script>

<style scoped>
.body {
  padding-top: 70px;
}
</style>
